<div class="container-fluid">
  <header class="print-no-margin-bottom now-context-info-header now-with-image-small">
    <div class="now-content-wrap">
      <h1 id="detail-seite-ueberschrift" #heading tabindex="-1" [innerHTML]="breakTitle"></h1>
      <div class="now-header-image">
        <img
          class="custom-image"
          [attr.id]="'angebot_' + termin.angebot.id + '_logo'"
          [ngSrc]="anbieterLogo"
          fill
          alt="Logo des Anbieters"
          (error)="hasImgError = true"
        />
      </div>
      <div class="now-info-tags">
        <div id="termin-beginn" class="now-icon now-icon-clock">
          <span class="visually-hidden">Beginn: </span
          >{{ termin.beginn ? (termin.beginn | date) : KEINE_ANGABE }}
        </div>
        <div id="termin-ende" class="now-icon now-icon-flag-checkered-fill">
          <span class="visually-hidden">Ende: </span
          >{{ termin.ende ? (termin.ende | date) : KEINE_ANGABE }}
        </div>
        <div id="termin-dauer" class="now-icon now-icon-clock-clockwise">
          <span class="visually-hidden">Dauer: </span>
          <now-wbsuche-lib-dauer-anzeige [termin]="termin"></now-wbsuche-lib-dauer-anzeige>
        </div>
        <div id="termin-ort" class="now-icon now-icon-map-pin">
          <span class="visually-hidden">Ort: </span>{{ termin.adresse?.ort || 'ortsunabhängig' }}
        </div>
        <div id="termin-weiterbildungsart" class="now-icon now-icon-certificate">
          <span class="visually-hidden">Weiterbildungsart:</span>{{ weiterbildungsart }}
        </div>
      </div>
      @if (termin.link) {
        <a
          id="btn_wbinfoseite"
          class="now-btn now-btn-primary now-btn-icon now-icon-arrow-square-out-after"
          [href]="termin.link"
          target="_blank"
          rel="noreferrer"
        >
          @if (isTablet$ | async) {
            Zum Weiterbildungsangebot
          } @else {
            Zur Infoseite Weiterbildungsangebot
          }
        </a>
        <div class="d-none d-print-block">
          Zur Infoseite des Angebots: <br />
          <a target="_blank" [href]="termin.link">{{ termin.link }}</a>
        </div>
      } @else if (!termin.link && termin.angebot.bildungsanbieter.email) {
        <a
          id="btn_wbmail"
          class="now-btn now-btn-primary now-btn-icon now-icon-envelope-after"
          title="Kontakt"
          href="mailto:{{ termin.angebot.bildungsanbieter.email }}"
        >
          Anbieter kontaktieren
        </a>
        <div class="d-none d-print-block">
          Zur Infoseite des Angebots: <br />
          <a href="mailto: {{ termin.angebot.bildungsanbieter.email }}">{{
            termin.angebot.bildungsanbieter.email
          }}</a>
        </div>
      }
      @if (isNowWbSuche) {
        <div class="now-toolbar now-toolbar-with-narrow-btns">
          <now-wbsuche-lib-favorit-toggle
            [entity]="favoriteEntity"
          ></now-wbsuche-lib-favorit-toggle>
        </div>
      }
    </div>
  </header>
</div>
